import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import * as action from '../redux/actions';
//  Components
import Categories from '../components/Categories/categories';
import Products from '../components/Products/products';
import Header from '../components/Header/header';

// Images
import PageBanner from '../components/Banner/page-banner';

class Catalogo extends Component {
   constructor(props) {
      super(props);
      this.state = {
         elementos: 12,
         pagina: 1,
         paginas: Math.ceil(this.props.catalogo_filtrado.length / 12),
         precio_min: 0,
         precio_max: 0,
      };
   }

   componentDidMount() {
      this.props.dispatch(action.get_all_catalogo());
   }

   render() {
      let minpagin = 1;
      let maxpagin = 10;

      const dec = Math.floor(this.state.pagina / (this.state.elementos - 2));
      maxpagin = (dec + 1) * 10;
      if (maxpagin >= this.state.paginas) {
         maxpagin = this.state.paginas;
      }
      minpagin = maxpagin - 11;
      if (minpagin < 1) {
         minpagin = 1;
      }

      return (
         <div className="flex main-catalogo">
            <Helmet>
               <title>CATÁLOGO - Expo Médica </title>
            </Helmet>
            <div className="column">
               <Header inicio={true}></Header>
               <div className="catalogo">
                  <div className="column  ">
                     <PageBanner title="Catálogo" />
                     <div className="catalog column">
                        <div className="white-space-24"></div>
                        <div className="justify-center">
                           <div className="container">
                              <div className="row-responsive">
                                 <div className="left">
                                    <div className="column">
                                       <Categories></Categories>
                                    </div>
                                 </div>
                                 <div className="right">
                                    <Products />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="white-space-48"></div>
            </div>
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      catalogo: state.catalogo,
      catalogo_filtrado: state.catalogo_filtrado,
      categories: state.categories,
      categories_selected: state.categories_selected,
   };
}

export default connect(mapStateToProps)(Catalogo);



// WEBPACK FOOTER //
// ./src/pages/catalogo.js